'use client';

import { useIsMobile, useMediaQuery } from '@shared/utils';
import type { GameLayout } from '../../../types/types';

/**
 * Custom hook, derives from screen params (width / height) layout for game play page.
 * Rules applied:
 *  - if mobile -> full screen
 *  - if inIframe defined -> full screen
 *  - if screen width below 1336px && screen height below 880px -> full screen
 *  - if none of the above -> frame (normal application flow)
 * @param inIframe
 * @returns GameLayout type
 */
function useGamePlayPageLayout(inIframe: string | string[] | undefined): GameLayout {
  const isMobile = useIsMobile({ breakpoint: 'md' });
  const isSmallDesktop = useMediaQuery('(width < 1366px)');
  const isShortScreen = useMediaQuery('(height < 880px)');

  if (isMobile || inIframe) return 'full';
  if (isSmallDesktop && isShortScreen) return 'full';
  return 'frame';
}

export { useGamePlayPageLayout };
